export default "__VITE_ASSET__Cl6ABapu__"